import { useOutletContext } from "react-router-dom";
import { ProjectRow, EmptyState } from "./components";

export default function DeliveriesPage() {
  const { briefs } = useOutletContext();
  const delivered = briefs
    .filter((b) => b.status === "Delivered")
    .sort((a, b) => new Date(b.delivered_at || b.created_at) - new Date(a.delivered_at || a.created_at));

  return (
    <div data-testid="deliveries-page">
      <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.28em] text-sky-400">Grapho Studio</p>
      <h1 className="mt-2 text-2xl font-extrabold tracking-tight text-white sm:text-3xl">Deliveries</h1>
      <p className="mt-1 text-sm text-slate-400">Completed designs, ready for your store.</p>

      {delivered.length === 0 ? (
        <div className="mt-8">
          <EmptyState
            testId="deliveries-empty"
            eyebrow="Nothing delivered yet."
            text="Your completed designs will appear here."
          />
        </div>
      ) : (
        <div data-testid="deliveries-list" className="mt-8 space-y-3">
          {delivered.map((b) => (
            <ProjectRow key={b.brief_id} brief={b} download detail dateIso={b.delivered_at} dateLabel="Delivered" />
          ))}
        </div>
      )}
    </div>
  );
}
